<template>
    <nav v-if="$device.desktop()" class="nav">
        <span v-for="(page, index) in pageLinks"
              :key="index"
              :class="{active: page.components.indexOf($route.name) >= 0}"
              class="nav-link-wrap">
            <router-link v-if="page.link" :to="page.link" @click.native="changePage()">
                <div v-text="page.name"></div>
            </router-link>
        </span>
        <span v-if="$store.state.profile.role == 'superAdmin'" class="nav-link-wrap">
            <a :href="$store.state.baseUrl + '/admin/auth-from-key?key=' + $store.state.profile.user.access_token"
               target="_blank">
              Admin
            </a>
        </span>
        <div class="responsive-nav">

            <div v-for="(page, index) in pageLinks" v-if="page.link"
                         :key="index"
                         @click="changePage(page.link)"
                         v-text="page.name"></div>
        </div>
    </nav>
</template>


<script>
    import {mapMutations} from 'vuex';
    export default {
        props:[
            'pageLinks'
        ],
        methods:{
            ...mapMutations({
            setData: "SET_DATA",
            }),
            changePage(link) {
                this.setData({
                    field: "scrollPositionPageOldCars",data: 0,
                })
                this.setData({
                    field:"scrollPositionPageDealers",data: 0,
                })
                this.setData({
                    field: "moduleOldCars.cars.scrollTop",
                    data: 0
                });
                if (link) this.$router.push(link);
            },
        },
        computed: {

            // pageLinks() {
            //     return [
            //         {
            //             link: "/",
            //             name: "Bílasölur",
            //             components: ['OldCars', 'Car']
            //         },
            //         {
            //             link: "/bilaumbod",
            //             name: "Bílaumboð",
            //             components: ['DealersCars', 'DealerCar']
            //         },
            //         {
            //             link: "/kjarabilar",
            //             name: "Kjarabílar",
            //             components: ['CarsInStock', 'CarInStock']
            //         },
            //         {
            //             link: this.blogURL,
            //             name: "Allt um bila",
            //             components: ['Blog', 'ReynsluaksturSimplePost', 'Fréttir', 'Viðburðir', 'Reynsluakstur', 'FréttirSimplePost']
            //         },
            //         {
            //             link: "/about-project",
            //             name: "Um okkur",
            //             components: ['AboutProject']
            //         }
            //     ];
            // },
        }
    }
</script>
